<template>
    <div class="row">
        <input-select class="col-12" :label="tipoLabel" v-model="form.tipo" :options="tipoOptions" ref="tipo" required/>
        <input-textarea class="col-12" label="Detalhamento" v-model="form.detalhamento" ref="detalhamento" required/>
        <input-textarea class="col-12" label="Justificativa" v-model="form.justificativa" ref="justificativa" required/>
        <input-money class="col-12 col-md-6" label="Valor R$" v-model="form.valor" ref="valor" required/>
        <input-select class="col-12 col-md-6" label="Mês da despesa" :options="mesesDepesas" v-model="form.mes" ref="mes" required/>
        
    </div>
</template>
<script>
import InputSelect from "@/components/inputs/InputSelect";
import InputTextarea from "@/components/inputs/InputTextarea";
import InputMoney from "@/components/inputs/InputMoney";

import {FormMixin} from "@/common/mixins/FormMixin";

import helpers from "@/common/utils/helpers";

export default {
    name: "Previsto",
    mixins: [FormMixin],
    props: {
        projeto : {
            type: Object,
            default: null
        },
        form : {
            type: Object,
            default: null
        },
        tipoLabel : {
            type: String,
            default: "Tipo de recurso"
        },
        tipoOptions : {
            default: []
        }
    },
    components: {
        InputSelect,
        InputTextarea,
        InputMoney
    },
    computed:{
        mesesDepesas(){
            let projeto = this.telaProponente ? this.projeto : this.projeto.projetoGestao;
            return helpers.criarArrayMes(`${projeto.anoInicio}-04-01`,projeto.duracao, true);
        },
        telaProponente :function(){
            return this.$route.name == 'projeto-gestao-proponente-detalhamento'
        },
    }
}
</script>
<style lang="">
    
</style>